export enum UpdateStrategy {
    Merge = 'merge',
    Override = 'override',
}

export enum ConfirmationEnum {
    Yes = 'yes',
    No = 'no',
}

export enum AppNextActionEnum {
    MoveToODOScreen = '10',
    MoveToVRNScreen = '20',
    CallStartChargingAPI = '30',
} 

export enum CSP {
    AWS = 'AWS',
    GCP = 'GCP',
}